<div>
  @if (initialized() && !loggedIn()) {
    <a href="#" (click)="onLogout()">
      <app-button>Uitloggen</app-button>
    </a>
  } @else {
    <app-is-loading />
  }
</div>
